<template id="#step2" >
  <h1 class="page-title">Information du produit</h1>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">       
    <section  class="item-bloc-form p-5">
      <h2>info produit</h2>
      <FormKit
        type="text"
        name="reference"
        label="Référence produit*"
        :value="reference"
        placeholder="Référence produit"
        validation="required|length:0,255"
        :validation-messages="{
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }"
      />
      <FormKit
        type="taglist"
        name="brands"
        label="Marque*"
        :options="searchBrands"
        max="1"
        validation="required|maxBrandLength"
        :validation-rules="{ maxBrandLength }"
        :validation-messages="{
            required: 'Ce champ est obligatoire.',
            maxBrandLength: 'Ce champ doit contenir maximum 50 caractères.',
          }"
        :allow-new-values="true"
        empty-message="Aucun résultat"
        :option-loader="loadBrand"
        @node="setCommitEventListener"
      />
      <FormKit
        type="hidden"
        name="brand"
        v-model="selectedBrand"
      />
      <FormKit
          type="text"
          name="productName"
          label="Nom du produit dans la boutique*"
          validation="length:0,255|required"     
          :validation-messages="{
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }"
          placeholder="Nom du produit dans la boutique"
        />

        <FormKit
          type="text"
          name="adminProductName"
          label="Nom du produit dans le backoffice"          
          placeholder="Nom du produit dans le backoffice"
          validation="length:0,255"
          :validation-messages="{
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }"
        />

        <FormKit
          type="text"
          name="shortDescription"
          label="Description courte"
          placeholder="Description courte"
          validation="length:0,255"
          :validation-messages="{
            length: 'Ce champ doit contenir maximum 255 caractères.',
          }"
        />
        <!-- TODO: Remove this field completely if no longer used in the backend or data model -->
         <FormKit
          type="select"
          name="urssafClassification"
          label="Sélectionner une catégorie"
          placeholder="Sélectionner une catégorie"
          :options="urssafClassification.values"
        />
        <FormKit
          type="taglist"
          multiple
          name="urssafEvent"
          label="Sélectionner un/des évènement(s)"
          placeholder="Sélectionner un/des évènement(s)"
          :options="urssafEvent.values"
        />
        <FormKit
            type="taglist"
            multiple
            name="socialEvent"
            validation="required"
            label="Sélectionner un/des évènement(s) ou catégorie(s)*"
            placeholder="Sélectionner un/des évènement(s) ou catégorie(s)"
            :options="socialEvent"
        />


    </section>

    <section  class="item-bloc-form p-5">
      <h2>{{ $t("ProductForm.StatusBloc.title") }}</h2>
    
        <FormKit
            type="checkbox"
            :label=" $t('ProductForm.StatusBloc.status') "
            name="active"
            :value="true"
          />
        <FormKit
            type="checkbox"
            :label=" $t('ProductForm.StatusBloc.closedLabel') "
            name="closedSale"
            v-model="is_sale_closed"
          />
          <FormKit
            type="checkbox"
            :label=" $t('ProductForm.StatusBloc.hiddenLabel') "
            name="hiddenProduct"
          />

      <FormKit
          type="date"
          name="enableDate"
          label="Date d'activation"
        />

        <FormKit
          type="date"
          name="disableDate"
          label="Date de désactivation"
        />

        <FormKit 
          type="text"
          label="Motif de la fermeture*"
          validation="required|length:0,255"
          v-model="closure_reason"
          :validation-messages="{
            required: 'Ce champ est obligatoire.',
            length: 'Ce champ doit contenir maximum 255 caractères.'
          }"
          name="saleClosingReason"
          v-if="is_sale_closed"
          
        />
    </section> 
   
    <section  class="item-bloc-form p-5">
      <h2>Fournisseur</h2>

      
      <FormKit
        type="checkbox"
        label="Envoi différé"
        name="delayedSending"
        v-if="  
          productPrototype !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' &&
          productPrototype !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
        "/>

      <FormKit
        type="autocomplete"
        label="Fournisseur*"
        name="supplier"
        validation="required"
        :validation-messages="{
              required: 'Veuillez sélectionner un fournisseur.',
            }"
        placeholder="Sélectionner un fournisseur"
        :options="searchSuppliers"
        v-model="supplier_model"

      />
      <FormKit
        type="taglist"
        multiple
        label="Moyen d’expédition*"
        name="shippingMethod"
        placeholder="Sélectionner un moyen d'expédition"
        validation="required"
        :options="optionsShippingMethods"
        v-model="shippingMethod_model"
        :validation-messages="{
              required: 'Au moins un moyen d’expédition doit être associé au produit.',
            }"
        v-if="productPrototype !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' &&
              productPrototype !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
        "/>

    </section>

    <section  class="item-bloc-form p-5" 
      v-if="productPrototype !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
      ">
      <h2>Gestion du stock</h2>
        <div class="grid grid-cols-2 grid-rows-1 gap-6">
            <FormKit
                type="number"
                label="Stock*"
                palceholder="Stock"
                name="stock"
                validation="required|matches:/^\d+$/"
                :validation-messages="{
                    required: 'Ce champ est obligatoire.',
                    matches: 'Veuillez entrer un nombre entier.'
                }"
            />
            <FormKit
                type="number"
                name="stockAlertThreshold"
                label="Seuil rupture de stock"
                palceholder="Seuil rupture de stock"
                validation="matches:/^\d+$/"
                :validation-messages="{
                    matches: 'Veuillez entrer un nombre entier.'
                }"
            />
        </div>
      <FormKit
        type="number"
        label="Limite/panier"
        name="limitByCart"
        validation="matches:/^\d+$/"
        :validation-messages="{
            matches: 'Veuillez entrer un nombre entier.'
        }"
      />
      <FormKit
        type="number"
        label="Limite/user"
        name="limitByUser"
        validation="matches:/^\d+$/"
        :validation-messages="{
            matches: 'Veuillez entrer un nombre entier.'
        }"
      />

    </section>

    <section  class="item-bloc-form p-5" 
      v-if="productPrototype == '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' " >
        <h2>Connexions</h2>
          
            <FormKit
              type="text"
              label="Identifiant"
              name="identifiant"
              validation="length:0,100"
              :validation-messages="{
                length: 'Ce champ doit contenir maximum 100 caractères.',
              }"
            />
            <FormKit
              type="text"
              label="Mot de passe"
              name="password"
              validation="length:0,100"
              :validation-messages="{
                length: 'Ce champ doit contenir maximum 100 caractères.',
              }"
            />
          
    </section>

    <section class="item-bloc-form p-5"
      v-if="productPrototype !== '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype !== '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype !=='6a3fe435-fdfd-11ed-a0b1-de1c3c38600f'
      ">
    
      <h2>Redirection & réduction</h2>
      <FormKit
        type="text"
        name="redirectionLink"
        label="Lien de redirection"
        placeholder="https://www.example.com..."
        validation="length:0,1400"
        :validation-messages="{
            length: 'Ce champ doit contenir maximum 1400 caractères.',
          }"
        />
      <FormKit
        type="radio"
        label="Type de réduction"
        name="reductionType"
        :options="[
            {label : 'Champ libre', value : 1},
            {label : 'En Pourcentage %', value : 2},
            {label : 'En euros €', value : 3}
        ]"
        v-model="discount_type"
        validation="required"
      />
      
      <FormKit
        type="textarea"
        name="reductionDescription"
        v-model="reductionDescriptionClosed"
        label="Description de la réduction*"
        v-if="discount_type == 1"
        validation="required|length:0,255"
        :validation-messages="{
            length: 'Ce champ doit contenir maximum 255 caractères.',
            required: 'Ce champ est obligatoire.',
          }"
      />
      <FormKit
        type="number"
        name="reductionValue"
        label="Réduction*"
        v-model="reductionValueClosed"
        validation="required|matches:/^[0-9]\d*$/"
        :validation-messages="{
          required: 'Ce champ est obligatoire.',
          matches: 'Veuillez entrer un nombre entier positif.'
        }"
        v-else
      />
    </section>

    <section class="item-bloc-form p-5"
    v-if="productPrototype !== '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f' && 
          productPrototype !== '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f' && 
          productPrototype !=='6a3fe435-fdfd-11ed-a0b1-de1c3c38600f' &&
          productPrototype !=='6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
    ">
      <h2>Code promotionnel</h2>
      <FormKit
        type="text"
        name="webPromoCode"
        label="Code promo internet"
        validation="length:0,255"
        :validation-messages="{
          length: 'Ce champ doit contenir maximum 255 caractères.',
        }"
      />
        
      <FormKit
        type="tel"
        label="Numéro de téléphone"
        name="phone"
        placeholder="xx xx xx xx"
        v-model="phoneNumber"
        :validation="phoneNumberValidation"
        :validation-messages="{
          length: 'Ce champ doit contenir maximum 20 caractères.',
          required: 'Ce champ est obligatoire si le code promo est renseigné.',
        }"
        validation-visibility="dirty"
      />
    
      <FormKit
        type="text"
        label="Code promo téléphone"
        name="codePromoPhone"
        v-model="promoCode"
        validation="length:0,255"
        :validation-messages="{
          length: 'Ce champ doit contenir maximum 255 caractères.',
        }"
      />
        
      <FormKit
        type="number"
        step="any"
        label="Prix d’appel"
        name="callPrice"
        :validation-rules="{ maximumDecimals }"
        validation="length:0,20|maximumDecimals"
        :validation-messages="{
          length: 'Ce champ doit contenir maximum 20 caractères.',
          maximumDecimals: maximumDecimalsError,
        }"
      />
    </section>      
  
    <section class="item-bloc-form p-5 " 
        v-if="
          productPrototype !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f' && 
          productPrototype !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
      ">
      <h2>Politique de prix</h2>
      <div class="grid grid-cols-1 md:grid-cols-4">
        <div class="pr-5">
          <FormKit
            type="select"
            label="Monnaie"
            name="country"
            :options="[
              {label :'€',value :'FR', attrs: { disabled: false }},
              {label :'$',value :'EN',  attrs: { disabled: true }}
            ]"
          />
        </div>
       <div class="pr-5">
          <FormKit
            type="number"
            step="any"
            label="Prix de vente*"
            :validation-rules="{ maximumDecimals }"
            validation="required|maximumDecimals"
            :validation-messages="{
                required: 'Ce champ est obligatoire.',
                maximumDecimals: maximumDecimalsError,
            }"
            name="price"
          />
        </div>
        <div class="pr-5">
          <FormKit
            type="select"
            label="Taxes*"
            name="tax"
            placeholder="Sélectionner une taxe"
            validation="required"
            :validation-messages="{
              required: 'Ce champ est obligatoire.',
            }"
            :options="taxes.values"
          />
        </div>
        <div>
          <FormKit
            type="number"
            step="any"
            label="Prix public*"
            name="publicPrice"
            v-model="publicPriceClosed"
            :validation-rules="{ maximumDecimals }"
            validation="required|maximumDecimals"
            :validation-messages="{
                required: 'Ce champ est obligatoire.',
                maximumDecimals: maximumDecimalsError,
            }"
            v-if="is_discount == 1"
          />
        </div>
          <div class="pr-5">
              <FormKit
                  type="number"
                  step="any"
                  label="Prix d’achat"
                  name="purchasingPrice"
                  :validation-rules="{ maximumDecimals }"
                  validation="maximumDecimals"
                  :validation-messages="{
                  maximumDecimals: maximumDecimalsError,
              }"
              />
          </div>
      </div>
      <div>
        <FormKit
            type="radio"
            label="Type de réduction"
            name="reductionTypeAsReduction"
            :options="[
               {label : 'Pas de réduction', value : 2},
               {label : 'Prix avec réduction', value : 1}
            ]"
            validation="required"
            v-model="is_discount"
            
          />
      </div>

    </section>

    <section class="item-bloc-form p-5" 
      v-if="productPrototype !== '6a3f537e-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype !== '6a3fc06d-fdfd-11ed-a0b1-de1c3c38600f' && 
            productPrototype !== '6a3ffb8f-fdfd-11ed-a0b1-de1c3c38600f'&& 
            productPrototype !== '6a401dea-fdfd-11ed-a0b1-de1c3c38600f'
    ">
      <h2>Conditions d’utilisation</h2>
      
        <FormKit
          type="checkbox"
          label="Utilisable en magasin"
          name="usableInStore"
          :value="true"
        />

        <FormKit
          type="checkbox"
          label="Utilisable en ligne"
          name="usableOnline"
          :value="true"
        />
    
      <FormKit
          type="radio"
          label="Utilisation drive"
          name="usableInDrive"
          :options="driveOptions"
          v-model="selectedDriveOption"
        
        />
    </section>

    <section class="item-bloc-form p-5">
      <h2>Géolocalisation</h2>
      <div>
        <FormKit
          type="radio"
          label="Type de récupération des adresses"
          name="geolocationType"
          v-if="geolocationOptions"
          :options="geolocationOptions"
          v-model="geolocation_type"
          validation="required"
          :validation-messages="{
                required: 'Ce champ est obligatoire.',
            }"
          
        />
      </div>
      <div>
        <FormKit
          type="text"
          name="geolocationApiKey"
          v-model="geolocationApiKeyClosed"
          label="Recherche dans l'API"
          v-if="typesGeolocationUuid && (geolocation_type == typesGeolocationUuid['Api'])"
          validation="required|length:0,200|matches:/^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s]+$/"
          :validation-messages="{
            length: 'Ce champ doit contenir maximum 200 caractères.',
            required: 'Ce champ est obligatoire.',
            matches: 'Seuls les lettres et les nombres sont acceptés.'
          }"
        />
        <FormKit
          id="repeater"
          name="geolocationAddresses"
          type="repeater"
          v-if="typesGeolocationUuid && (geolocation_type == typesGeolocationUuid['Manual'])"
          label="Adresses"
          #default="{ index }"
          add-label="+"
          min="1"
          max="10"
          v-model="geolocationAddresses"
        >
            <FormGeolocation
                :index="index"
                :number="index + 1"
                :reference="geolocationAddresses[index]"
                :optionsCountry="optionsCountry"
            />
        </FormKit>
      </div>
    </section>
    
  </div>
</template>


<script setup lang="ts">
  import ApiService from "@/_services/api.service"
  import Property from "@/models/product/property/Property";
  import PropertyValue from "@/models/product/property/PropertyValue";
  import TagListOptions from "@/models/modules/formkit/TagListOptions";
  import {onMounted, Ref, ref, computed, watch} from "vue";
  import { useProductStore } from "@/stores/product/prototypeStore";
  import { urssafEvent, urssafClassification } from "@/constants/product/properties";
  import { taxes } from "@/constants/product/taxes";
  import FormGeolocation from "@/components/forms/product/FormGeolocation.vue";
  import {getOptionsCountry} from "@/_services/geolocation/country";

  let optionsCountry = getOptionsCountry();
  
  interface PropertyValuePayload {
    name: string;
    uuid: string;
  }
  const driveOptions = [
    { label: 'Utilisable en drive', value: true },
    { label: 'Non utilisable en drive', value: false },
    { label: 'Information non renseignée', value: null }
  ];
  const selectedDriveOption = ref(null);

  const maximumDecimalsError = 'Maximum 2 décimales après la virgule.';
  const maxErrorMEssage = 'Ce champ doit comporter maximum 17 décimales';
  let propertyBrand: Property;
  let propertyUrssafEvent = ref({});
  let socialEvent = ref<{ label: string; value: string}[]>([]);
  let propertyUrssafClassification = ref({});
  let propertyTaxes = ref({});
  let is_sale_closed = ref();
  let discount_type = ref(2);
  let geolocationOptions = ref();
  let typesGeolocationUuid = ref();
  let geolocation_type = ref('');
  const closure_reason = ref('');
  const publicPriceClosed = ref('');
  const reductionDescriptionClosed = ref('');
  const reductionValueClosed = ref('');
  const geolocationApiKeyClosed = ref('');
  const geolocationAddresses = ref([]);
  const purchasingPrice = ref([]);

  let is_discount = ref(1);
  const selectedBrand: Ref<PropertyValuePayload | null> = ref(null);
  let supplier_model = ref('');
  let optionsShippingMethods = ref([]);
  let shippingMethod_model  = ref([]);
  onMounted(async () => {
    await getBrand();
    await getUrssafEvent();
    await getUrssafClassification();
    await getTaxes();
    await getTypesGeolocationOptions();
    await getSocialEvent();
  })
  

  const promoCode = ref('');
  const phoneNumber = ref('');

  const phoneNumberValidation = computed(() => {
    if (promoCode.value && !phoneNumber.value) {
      return 'required';
    }
    return 'length:0,20';
  });

  const searchInput = ref('');

  const searchValidation = computed(() => {
    if (searchInput.value.length > 50) {
      return 'searchLength'; // Return the validation error key
    } else {
      return null; // Return null if validation passes
    }
  });
  
  function maxBrandLength(node) {
    const value = node.value
    return value[0].length <= 50;
  }

  function maximumDecimals(node, maxDecimals = 2) {
    const value = node.value;
    const regex = new RegExp(`^\\d+(\\.\\d{1,${maxDecimals}})?$`);
    return regex.test(value);
  }

  function maximumDecimalsGeoloc(node, maxDecimals = 17) {
    const value = node.value;
    const regex = new RegExp(`^-?\\d+(\\.\\d{1,${maxDecimals}})?$`);
    return regex.test(value);
  }

  async function searchBrands({ search }) {
    if(!search || search.length <= 2) return [];
    
    return propertyBrand.propertyValues.reduce((accumulator: Array<TagListOptions>, brand: PropertyValue) => {
      if (brand.value.toLowerCase().includes(search.toLowerCase())) {
        accumulator.push({
          label: brand.value,
          value: brand.uuid
        })
      }
      return accumulator;
    }, []);
  }

  async function getBrand() {
    const fetchedBrand = await ApiService.get('properties/e7cc42c0-fa45-11ed-a0b1-de1c3c38600f');
    propertyBrand = fetchedBrand.data.data;
  }

  async function getUrssafEvent() {
    const fetchedUrssafEvent = await ApiService.get('properties/e7d653d5-fa45-11ed-a0b1-de1c3c38600f');
    propertyUrssafEvent.value = formatPropertyValueData(fetchedUrssafEvent.data.data);
  }

  function formatSocialEventData(response: any): { label: string; value: string }[] {
      const items = response;
      if (!Array.isArray(items)) return [];
      return items.map((item: any) => ({
          label: item.name,
          value: item.uuid
      }));
  }

  async function getSocialEvent() {
      try {
          const res = await ApiService.get('social_events');
          socialEvent.value = formatSocialEventData(res.data.data);
      } catch (error) {
          console.error('Erreur API socialEvent:', error);
      }
  }
  
  async function getUrssafClassification() {
    const fetchedUrssafClassification = await ApiService.get('properties/e7d49bb6-fa45-11ed-a0b1-de1c3c38600f');
    propertyUrssafClassification.value = formatPropertyValueData(fetchedUrssafClassification.data.data);
  }
  async function getTaxes() {
    const fetchedTaxes = await ApiService.get('taxes');
    const taxOptions = Object.keys(fetchedTaxes.data.data).map((key) => ({
      value: fetchedTaxes.data.data[key].uuid,
      label: `${fetchedTaxes.data.data[key].tax.toString()}%`
    }));


    propertyTaxes.value = taxOptions;
  }
  function formatPropertyValueData(data) {
    return data.propertyValues.reduce((accumulator: Record<string, string>, propertyValue: PropertyValue) => {
      accumulator[propertyValue.uuid] = propertyValue.value;
      return accumulator;
    }, {});
  }

  async function loadBrand(id, cachedOption) {
    selectedBrand.value = {
      name: cachedOption.label,
      uuid: cachedOption.label == cachedOption.value ? '' : cachedOption.value
    }
  }

  function setCommitEventListener(node) {
    node.on('commit', ({ payload }) => {
      if(!payload.length) {
        selectedBrand.value = null;
      }
    })
  }


  const productStore = useProductStore();
  const invokeGetProductPrototype = () => {
    productStore.getProductPrototype();
  };
  invokeGetProductPrototype()
  const productPrototype = computed(() => productStore.getProductPrototype());

  async function getTypesGeolocationOptions() {
    const fetchTypesGeolocationOptions = await ApiService.get('properties/7d4e611a-2d5f-11ee-9793-de1ca4386011');
    typesGeolocationUuid.value = [];
    geolocationOptions.value = [];
    fetchTypesGeolocationOptions.data.data.propertyValues.forEach((val: any) => {
      typesGeolocationUuid.value[val.value] = val.uuid;
      let label = '';
      switch (val.value) {
        case 'Manual':
          label = 'Manuelle';
          break;
        case 'Api':
          label = 'Depuis l\'API';
          break;
        default:
          label = 'Géolocalisation désactivée';
      }
      geolocationOptions.value.push({
        label: label,
        value: val.uuid
      });
    });
      geolocation_type.value = '';
  }

  async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
      return {
        label: val.name,
        value: val.uuid
      }
    });
  }


  watch(
    supplier_model,
    (value) => {
      if (!value) {
        optionsShippingMethods.value = [];
        shippingMethod_model.value = null;
        return;
      }
      ApiService.get(`suppliers/${value}/shipping_methods?status=1&itemsPerPage=1000`).then(({data}) => {
        optionsShippingMethods.value = data.data.map((val: any) => {
          return {
            label: val.name,
            value: val.uuid
          }
        });
      });

    },
    {immediate: true}
  );



  const generateReference = () => {
    let reference = '';
    let hasLetter = false;
    let hasDigit = false;

    while (reference.length < 13) {
      const charCode = Math.floor(Math.random() * (122 - 48 + 1) + 48);
      if ((charCode >= 48 && charCode <= 57) || (charCode >= 65 && charCode <= 90)) {
        reference += String.fromCharCode(charCode);
        if (charCode >= 65) hasLetter = true;
        if (charCode >= 48 && charCode <= 57) hasDigit = true;
      }
    }

    if (!hasLetter) reference = reference.slice(0, -1) + 'A';
    if (!hasDigit) reference = reference.slice(0, -2) + '1' + reference.slice(-1);

    return reference;
  };

  const reference = ref(generateReference());
 
</script>



<style scoped lang="scss">
  .item-bloc-form {
    background-color: #f2f9ff;
    h2{
      text-transform: uppercase;
      padding-bottom: 10px;
      border-bottom: 1px solid #0A3382;
      margin-bottom: 10px;
      color : #0A3382;
    }
    
  }
  label{
    font-weight: normal;
  }
  
</style>



